import { defineModule, type ModuleBase } from "@repo/module-kit"
import type { LucideIcon } from "lucide-react"
import type { ComponentType, LazyExoticComponent } from "react"

export type RouteComponent = ComponentType | LazyExoticComponent<ComponentType>

export interface DashboardNavItem {
  group: string
  title: string
  to: string
  icon: LucideIcon
}

export interface DashboardRoute {
  /** Absolute, as in `/clients`; list `/clients/:id` as its own entry. */
  path: string
  component: RouteComponent
}

/** What a feature contributes to the dashboard. */
export interface DashboardModule extends ModuleBase {
  nav?: DashboardNavItem[]
  routes: DashboardRoute[]
}

export function defineDashboardModule(
  module: DashboardModule
): DashboardModule {
  return defineModule(module)
}
